import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import PhotoModeration from "./PhotoModeration";
import ShopInfo from "./ShopInfo";
import ShopInsights from "./ShopInsights";
import ShopMessages from "./ShopMessages";
import ShopCustomers from "./ShopCustomers";
import ShopSettings from "./ShopSettings";

// Winkeldashboard-omhulsel: houdt alleen bij wat de header nodig heeft
// (naam, plan, klantenaantal) en welke tab actief is. Alle tab-specifieke
// state en logica leeft in de eigen componenten hieronder (ShopInfo,
// ShopInsights, ShopCustomers, PhotoModeration, ShopMessages,
// ShopSettings) — elk haalt zijn eigen data op via shopId, zodat dit
// bestand overzichtelijk blijft in plaats van één 1000+ regels bestand.
const ShopDashboard = ({ shopId, onBack }) => {
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("insights");
  const [headerInfo, setHeaderInfo] = useState({ name: "", plan: "free" });
  const [customerCount, setCustomerCount] = useState(0);

  useEffect(() => {
    if (!shopId) return;
    const shopRef = doc(db, "shops", shopId);
    getDoc(shopRef).then((docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setHeaderInfo({ name: data.name || "", plan: data.plan || "free" });
      }
      setLoading(false);
    });
  }, [shopId]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <div className="card">
          <div className="card-body text-center">
            <div className="loading-spinner" style={{ margin: '0 auto 20px' }}></div>
            <p>Winkel laden...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* Header */}
      <div className="portal-header">
        <div className="portal-header-inner">
          <div>
            <div className="portal-eyebrow">Cupdate Portal</div>
            <h1 style={{ margin: '2px 0 0' }}>{headerInfo.name || "Mijn Winkel"}</h1>
          </div>
          <div style={{ textAlign: 'right' }}>
            <span className="status-pill">
              <span className="dot" />
              {customerCount} klant{customerCount === 1 ? '' : 'en'}
            </span>
          </div>
        </div>
      </div>

      <div className="portal-shell">
        {/* Navigation Tabs */}
        <div className="tabbar">
          {[
            { id: "insights", label: "Inzichten", icon: "📈" },
            { id: "info", label: "Informatie", icon: "📊" },
            { id: "customers", label: "Klanten", icon: "👥" },
            { id: "photos", label: "Foto's", icon: "📸" },
            { id: "messages", label: "Feed", icon: "📰" },
            { id: "settings", label: "Instellingen", icon: "⚙️" }
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`tabbar-btn ${activeTab === tab.id ? 'is-active' : ''}`}
            >
              <span>{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        {activeTab === "insights" && (
          <ShopInsights shopId={shopId} />
        )}

        {activeTab === "info" && (
          <ShopInfo key={`${shopId}-${customerCount}`} shopId={shopId} />
        )}

        {activeTab === "customers" && (
          <ShopCustomers shopId={shopId} onCountChange={setCustomerCount} />
        )}

        {activeTab === "photos" && (
          <div className="card card-flat">
            <div className="card-body" style={{ padding: 0 }}>
              <PhotoModeration shopId={shopId} />
            </div>
          </div>
        )}

        {activeTab === "messages" && (
          <div className="card card-flat">
            <div className="card-header">
              <h3>Feed</h3>
            </div>
            <div className="card-body">
              <ShopMessages shopId={shopId} shopName={headerInfo.name} />
            </div>
          </div>
        )}

        {activeTab === "settings" && (
          <ShopSettings shopId={shopId} onSaved={(update) => setHeaderInfo(prev => ({ ...prev, ...update }))} />
        )}
      </div>
    </div>
  );
};

export default ShopDashboard;
